export default [
  {
    path: 'risk/list',
    name: 'Risk List',
    component: () => import('@/views/risk/list/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:list',
    },
  },
  {
    path: 'risk/detail',
    name: 'Risk Detail',
    component: () => import('@/views/risk/details/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:detail',
      name: 'message.risk.itemsData',
      backPath: '/risk/list',
    },
  },
  {
    path: '/risk/ethoca',
    name: 'Risk Ethoca',
    redirect: '/risk/ethoca/enrollments/list',
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca',
    },
  },
  {
    path: 'risk/ethoca/alerts/list',
    name: 'Risk Ethoca Alerts List',
    component: () => import('@/views/risk/ethoca/alerts/list/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca:alerts:list',
      activeMenu: '/risk/ethoca',
    },
  },
  {
    path: 'risk/ethoca/alerts/view',
    name: 'Risk Ethoca Alerts View',
    component: () => import('@/views/risk/ethoca/alerts/view/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca:alerts:view',
      backPath: '/risk/ethoca/alerts/list',
      name: 'message.alert.ethocaAlertDetails',
      activeMenu: '/risk/ethoca',
    },
  },
  {
    path: 'risk/ethoca/enrollments/list',
    name: 'Risk Ethoca Enrollments List',
    component: () => import('@/views/risk/ethoca/enrollments/list/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca:enrollments:list',
      activeMenu: '/risk/ethoca',
    },
  },
  {
    path: 'risk/ethoca/enrollments/edit',
    name: 'Risk Ethoca Enrollments Edit',
    component: () => import('@/views/risk/ethoca/enrollments/edit/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca:enrollments:edit',
      backPath: '/risk/ethoca/enrollments/list',
      hideMenu: true,
      activeMenu: '/risk/ethoca',
    },
  },
  {
    path: 'risk/ethoca/enrollments/view',
    name: 'Risk Ethoca Enrollments View',
    component: () => import('@/views/risk/ethoca/enrollments/view/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:ethoca:enrollments:view',
      backPath: '/risk/ethoca/enrollments/list',
      name: 'message.alert.ethocaEnrollmentDetails',
      activeMenu: '/risk/ethoca',
    },
  },
  {
    path: '/risk/rdr',
    name: 'Risk RDR',
    redirect: '/risk/rdr/enrollments/list',
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr',
    },
  },
  {
    path: 'risk/rdr/alerts/list',
    name: 'Risk RDR Alerts List',
    component: () => import('@/views/risk/rdr/alerts/list/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr:alerts:list',
      activeMenu: '/risk/rdr',
    },
  },
  {
    path: 'risk/rdr/alerts/view',
    name: 'Risk RDR Alerts View',
    component: () => import('@/views/risk/rdr/alerts/view/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr:alerts:view',
      backPath: '/risk/rdr/alerts/list',
      name: 'message.alert.rdrAlertDetails',
      activeMenu: '/risk/rdr',
    },
  },
  {
    path: 'risk/rdr/enrollments/list',
    name: 'Risk RDR Enrollments List',
    component: () => import('@/views/risk/rdr/enrollments/list/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr:enrollments:list',
      activeMenu: '/risk/rdr',
    },
  },
  {
    path: 'risk/rdr/enrollments/edit',
    name: 'Risk RDR Enrollments Edit',
    component: () => import('@/views/risk/rdr/enrollments/edit/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr:enrollments:edit',
      backPath: '/risk/rdr/enrollments/list',
      hideMenu: true,
      activeMenu: '/risk/rdr',
    },
  },
  {
    path: 'risk/rdr/enrollments/view',
    name: 'Risk RDR Enrollments View',
    component: () => import('@/views/risk/rdr/enrollments/view/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:rdr:enrollments:view',
      backPath: '/risk/rdr/enrollments/list',
      name: 'message.alert.rdrEnrollmentDetails',
      activeMenu: '/risk/rdr',
    },
  },
];
